import React, { useContext } from 'react';
import axios from 'axios';
import { NavLink, Link } from 'react-router-dom'
import { TimelineMax, Power1 } from "gsap/all"
import { KeywordsContext } from '../../contexts/KeywordsProvider';

import styled from 'styled-components';
import theme from '../../theme';

import Logo from "../../images/nav-logo.png";
import { ReactComponent as ArrowDown } from "../../icons/arrow-down.svg";
import { ReactComponent as FacebookIcon } from "../../icons/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../icons/instagram.svg";

const Nav = (props) =>  {
  const navRef = React.useRef();
  const keywords = useContext(KeywordsContext);

  const [state, setState] = React.useState({
      navItems: null,
      langDropdownActive: false,
      navOpened: false
  });

  React.useEffect(() => {
    axios
      .get(`https://www.paralele.me/api/nav/index.php?lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        setState(oldState => ({ ...oldState, navItems: data }))
      });

    
  }, []);

  React.useEffect(() => {
    const timeline = new TimelineMax({ paused: true })

    timeline
      .from(navRef.current, 0.8, {
        autoAlpha: 0,
        y: -25,
        ease: Power1.ease
      })

      timeline.play();

      const scrollListener = (e) => {
        const scrollTop = window.scrollY
        const body = document.querySelector('body');

        if (scrollTop > 150) {
          if (!body.classList.contains('scrolled')) {
            document.querySelector('body').classList.add('scrolled')
          }
        } else {
          if (body.classList.contains('scrolled')) {
            document.querySelector('body').classList.remove('scrolled')
          }
        }
      }
  
      window.addEventListener('scroll', scrollListener);
  
      return () => {
        window.removeEventListener('scroll', scrollListener);
      }
  
  }, []);

  const handleLanguageDropdown = () => {
    setState(prevState => ({
      ...prevState,
      langDropdownActive: !prevState.langDropdownActive
    }));
  }

  const handleNavClick =  () => {
    setState(prevState => ({
      ...prevState,
      navOpened: !prevState.navOpened
    }))
  }


  const { location } = props;

  return (
    <Navigation ref={navRef}>
      <NavWrapper className='container'>
        <Link to={`/${window.language}`} className="navbar-brand">
          <img src={Logo} alt="Nav logo" />
        </Link>
        <NavToggleBtn type="button" onClick={handleNavClick}>
          <NavToggleBox>
            <NavToggleInner className={state.navOpened ? 'active' : ''}></NavToggleInner>
          </NavToggleBox>
        </NavToggleBtn>
        <TopNavWrapper>
          <TopNav>
            <DropdownTrigger onClick={handleLanguageDropdown}>
              <span>{window.language === 'me' ? 'Mne' : 'Eng'}</span> <ArrowDown />
            </DropdownTrigger>
            <LanguageDropdown className={state.langDropdownActive ? 'active' : ''}>
              <ul>
                <li><a href="/me">Mne</a></li>
                <li><a href="/en">Eng</a></li>
              </ul>
            </LanguageDropdown>
          </TopNav>
          <SocialIcons>
            <li>
              <a href={keywords.facebookUrl} target='_blank' rel="noopener noreferrer">
                <FacebookIcon />
              </a>
            </li>
            <li>
              <a href={keywords.instagramUrl} target='_blank' rel="noopener noreferrer">
                <InstagramIcon />
              </a>
            </li>
          </SocialIcons>
        </TopNavWrapper>

        <div className={state.navOpened ? "nav-wrapper active" : "nav-wrapper"}>
          <div id="navbar" className="col navbar-collapse collapse">
            <ul className="nav navbar-nav">
              {
                state.navItems && (
                  state.navItems.map((item, i) => {
                    if (item.id === "1") {
                      let homeClass = "";
                      if (location.pathname.includes("/projekat/") || location.pathname.includes("/project/") || location.pathname === "/") {
                        homeClass = "active";
                      }
                      return <li key={i}><NavLink to={`/${window.language}/${item.link}`} onClick={() => setState(prevState => ({...prevState, navOpened: false}))} className={homeClass} activeClassName="active" exact>{item.name}</NavLink></li>
                    } else if (item.id === "25") {
                      let newsClass = "";
                      if (location.pathname.includes("/news/") || location.pathname.includes("/novosti/")) {
                        newsClass = "active";
                      }
                      return <li key={i}><NavLink to={`/${window.language}/${item.link}`} onClick={() => setState(prevState => ({...prevState, navOpened: false}))} className={newsClass} activeClassName="active" exact>{item.name}</NavLink></li>
                    } else {
                      return <li key={i}><NavLink to={`/${window.language}/${item.link}`} onClick={() => setState(prevState => ({...prevState, navOpened: false}))} activeClassName="active" exact>{item.name}</NavLink></li>
                    }
                  })
                )
              }
            </ul>
            <MobileBelowNav className="mobile-below-nav d-lg-none">
              <div className="mb-3">
                <DropdownTrigger onClick={handleLanguageDropdown}>
                  <span>{window.language === 'me' ? 'Mne' : 'Eng'}</span> <ArrowDown />
                </DropdownTrigger>
                <LanguageDropdown className={state.langDropdownActive ? 'active' : ''}>
                  <ul>
                    <li><a href="/me">Mne</a></li>
                    <li><a href="/en">Eng</a></li>
                  </ul>
                </LanguageDropdown>
              </div>
              <SocialIcons>
                <li>
                  <a href={keywords.facebookUrl} target='_blank' rel="noopener noreferrer">
                    <FacebookIcon />
                  </a>
                </li>
                <li>
                  <a href={keywords.instagramUrl} target='_blank' rel="noopener noreferrer">
                    <InstagramIcon />
                  </a>
                </li>
              </SocialIcons>
            </MobileBelowNav>
          </div>
        </div>
      </NavWrapper>
    </Navigation >

  );
}

const NavWrapper = styled.div`
  position: relative;
  display: flex;
`

const MobileBelowNav = styled.div`
  width: 120px;
  margin: 0 auto;
  visibility: hidden;
  opacity: 0;
  transform: translateX(-20px);
  transition: all .5s ease;

  svg {
    fill: white !important;
  }

  p {
    justify-content: center;
  }

  p,
  span {
    color: white;
    text-align: center;
  }
`

const NavToggleBox = styled.span`
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative
`

const NavToggleInner = styled.span`
  display: block;
  margin-top: -2px; 
  top: auto;
  bottom: 0;
  transition-duration: 0.13s;
  transition-delay: 0.13s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);

  &,
  &:before,
  &:after {
    width: 30px;
    height: 3px;
    background-color: #000;
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  &:before,
  &:after {
    content: "";
    display: block; 
  }

  &:before {
    top: -10px;
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  &:after {
    bottom: -10px;
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear;
  }

  &.active {
    background-color: white;
    transform: translate3d(0, -10px, 0) rotate(-45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); 

    &:after {
      background-color: white;
      top: 0;
      opacity: 0;
      transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear;
    }

    &:before {
      background-color: white;
      top: 0;
      transform: rotate(-90deg);
      transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1); 
    }
  }
`

const NavToggleBtn = styled.button`
  @media(min-width: 992px) {
    display: none;
  }
  &:active,
  &:focus {
    outline: none;
  }

  z-index: 50;
  padding: 15px 5px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible; 

  position: fixed;
  top: 20px;
  right: 10px;
`

const SocialIcons = styled.ul`
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
  margin-left: 20px;

  li {
    width: 30px;
    height: 30px;
    background: ${theme.colors.primary};
    border-radius: 50%;
    margin: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      line-height: 13px;
    }

    svg {
      width: 17px;
      height: 17px;
      fill: white;
    }
  }
`

const DropdownTrigger = styled.p`
  cursor: pointer;
  color: ${theme.colors.primary};
  font-size: 18px;
  display: flex;
  align-items: center;

  svg {
    margin-left: 5px;
    width: 12px;
    height: 12px;
    fill: ${theme.colors.primary};
  }

  &:hover {
    text-decoration: none;
  }
`

const TopNavWrapper = styled.div`
  display: none;

  @media(min-width: 992px) {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    right: 42px;
    z-index: 55;
  }
`

const TopNav = styled.div`
  position: relative;
`

const LanguageDropdown = styled.div`
  position: absolute;
  background: white;
  box-shadow: 0 0 20px rgba(0,0,0,.1);
  border-radius: 5px;
  z-index: 55;
  color: white;
  display: none;
  padding: 10px;
  min-width: 120px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      border-top: 1px solid rgba(0, 0, 0, .1);
      &:nth-child(1) {
        border-top: none;
      }
      a {
        padding: 5px;
        display: block;
        color: ${theme.colors.primary};
        transition: all .3s ease;

        &:hover {
          background: rgba(0, 0, 0, .1);
          text-decoration: none;
        }
      }
    }
  }

  &.active {
    display: block;
  }
`

const Navigation = styled.nav`
  z-index: 1225;
  display: flex;
  align-items: center;
  transition: box-shadow .5s ease;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: white;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  padding: 20px 0 10px 5px;

  @media(min-width: 992px) {
    padding: 30px 0 30px 15px;
    margin-bottom: 80px;
  }

  .nav-wrapper {
    margin-top: auto;
    margin-left: auto;

    @media(max-width: 991px) {
      opacity: 0;
      visibility: none;
      pointer-events: none;
      transition: all .3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${theme.colors.primary};
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    }

    &.active {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;

      .mobile-below-nav {
        opacity: 1;
        visibility: visible;
        transition-delay: 1s;
        transform: translateX(0);
      }

      li {
        visibility: visible;
        opacity: 1;
        transform: translateX(0);

        &:nth-child(1) {
          transition-delay: .1s;
        }
        &:nth-child(2) {
          transition-delay: .3s;
        }
        &:nth-child(3) {
          transition-delay: .5s;
        }
        &:nth-child(4) {
          transition-delay: .7s;
        }
      }
    }
  }

  .nav {
    display: flex;
    list-style: none;

    @media(max-width: 991px) {
      flex-direction: column;
      text-align: center;
      padding: 0;
    }

    li {
      margin: 0 20px;

      @media(max-width: 991px) {
        margin: 20px;
        opacity: 0;
        visibility: hidden;
        transition: all .7s ease;
        transform: translateX(-20px);

        
      }

      a {
        font-size: 19px;
        text-transform: uppercase;
        font-weight: 200;
        color: ${theme.colors.primary};
        position: relative;

        @media(max-width: 991px) {
          color: white;
        }

        &:hover,
        &.active {
          text-decoration: none;

          &:before {
            background: 0 0;
          }
          &:after {
            transform: scaleX(1);
            transform-origin: left center;
          }
        }

        &:before,
        &:after {
          content: "";
          transition: all .2s cubic-bezier(.19,1,.22,1);
          position: absolute;
          left: 0;
          bottom: -3px;
          width: 100%;
          height: 2px;
          margin: auto;
          pointer-events: none;
        }

        &:after {
          transition: transform .2s cubic-bezier(.215,.61,.355,1);
          background-color: ${theme.colors.primary};
          transform: scaleX(0);
          transform-origin: right center;
        }
      }
    }
  }
`;

export default Nav;